enum DialogNames {
    logout = 'logout',
}

export default DialogNames;
